import { useState } from "react";
import { Mail, Hash, KeyRound } from "lucide-react";
import { Shell, Head, Field, Btn, Alert } from "../../components/ui/AuthComponents";
import { useAuth } from "../../hooks/useAuth";

export default function ResidentLogin({ onBack, onSuccess }) {
  const { loginResident } = useAuth();

  const [f, setF] = useState({ code: "", unit: "", email: "", pass: "" });
  const [e, setE] = useState({});
  const [loading, setLoading]   = useState(false);
  const [apiError, setApiError] = useState("");

  const upd = k => v => {
    setF(p => ({ ...p, [k]: v }));
    setE(p => ({ ...p, [k]: "" }));
    setApiError("");
  };

  const validate = () => {
    const err = {};
    if (!f.code.trim())                       err.code  = "Required";
    if (!f.unit.trim())                       err.unit  = "Required";
    else if (isNaN(+f.unit) || +f.unit <= 0)  err.unit  = "Invalid unit number";
    if (!f.email.trim())                      err.email = "Email required";
    else if (!/\S+@\S+\.\S+/.test(f.email))   err.email = "Invalid email format";
    if (!f.pass)                              err.pass  = "Password required";
    else if (f.pass.length < 6)               err.pass  = "Min 6 characters";
    return err;
  };

  const submit = async () => {
    const err = validate();
    if (Object.keys(err).length) { setE(err); return; }

    setLoading(true);
    setApiError("");

    const result = await loginResident({
      condoCode:  f.code,
      unitNumber: f.unit,
      email:      f.email,
      password:   f.pass,
    });

    setLoading(false);

    if (result.error) {
      setApiError(result.error);
    } else {
      onSuccess("resident");
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") submit(); };

  return (
    <Shell role="resident" onBack={onBack}>
      <Head
        eyebrow="Resident Portal"
        title="Sign in to your unit"
        sub="Enter your property credentials to continue"
      />
      <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>

        {/* API-level error banner */}
        {apiError && (
          <div className="fu">
            <Alert type="warn">{apiError}</Alert>
          </div>
        )}

        <div className="two-col">
          <Field
            label="Condo Code"
            value={f.code}
            onChange={upd("code")}
            placeholder="CAN-4821"
            icon={KeyRound}
            error={e.code}
            autoFocus
            delay="d1"
            maxLength={12}
            onKeyDown={handleKeyDown}
          />
          <Field
            label="Unit No."
            type="number"
            value={f.unit}
            onChange={upd("unit")}
            placeholder="204"
            icon={Hash}
            error={e.unit}
            delay="d2"
            onKeyDown={handleKeyDown}
          />
        </div>

        <Field
          label="Email Address"
          type="email"
          value={f.email}
          onChange={upd("email")}
          placeholder="you@example.com"
          icon={Mail}
          error={e.email}
          delay="d3"
          onKeyDown={handleKeyDown}
        />
        <Field
          label="Password"
          type="password"
          value={f.pass}
          onChange={upd("pass")}
          placeholder="••••••••"
          error={e.pass}
          delay="d4"
          onKeyDown={handleKeyDown}
        />

        <div className="fu d5" style={{ marginTop: 4 }}>
          <Btn label="Sign In as Resident →" loading={loading} onClick={submit} />
        </div>
      </div>
    </Shell>
  );
}